export enum Phase {
  ShareProgram = 'ShareProgram',
  CreateChallenge = 'CreateChallenge',
}
